import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'
import styled from 'styled-components';

const Styles = styled.div`
    .ql-toolbar{
        padding-bottom: 15px;
    }
    .ql-container{
        border-bottom-left-radius: 0.5em;
        border-bottom-right-radius: 0.5em;
    }
    .ql-editor{
        height: 180px;
    }
    .ql-snow.ql-toolbar {
        display: block;
        background: #eaecec;
        border-top-left-radius: 0.5em;
        border-top-right-radius: 0.5em;
        position: sticky!important;
        top: 0;
        z-index: 10;
    }
`;

const InputEditQuill =({onChangeText,template,id}) => {
    const [value, setValue] = useState(template || '')
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline','strike'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            [{ 'header': [2, 3, false] }],
            [{ 'align': [] }],
            [{ 'color': [] }, { 'background': [] }], 
            ['clean']
        ],
    }
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet', 'indent','background','color','align'
      ]
    const onChangeTemplete = (newEditor) =>{
        setValue(newEditor)
        onChangeText(newEditor)
    }

    useEffect(() => {
        setValue(template)
        onChangeText(template)
    }, [template])
    return (
        <Styles>
            <ReactQuill
                id={id}
                theme="snow" 
                value={value} 
                onChange={onChangeTemplete} 
                modules={modules}
                formats={formats}
            />
        </Styles>
    )
}

export default InputEditQuill